import React, { useState, useContext, useRef } from "react";
import { useEffect } from "react";
import {
  useHistory,
  useLocation,
  useParams,
  withRouter,
} from "react-router-dom";
import ProductAddToCart from "../AddToCart/ProductAddToCart";
import { ProductsContext } from "../../../context/ProductsContext";
import CartContext from "../../../context/CartContext";
import productData from "../../../data";
const Single = (props) => {
  const product = productData.getProductBySlug(props.match.params.id);
  console.log("clg prod in single from data", product);
  const { image_url, title, brand, description, price } = product;

  return (
    <section className="content-area product-single-page">
      <div className="product-imgs">
        <div className="product">
          <div className="circle">
            <img src={image_url} alt="sneaker" />
          </div>
        </div>
      </div>
      <div className="product-detail">
        <div className="titles">
          <div className="brand">{brand}</div>
          <div className="product">
            <div className="product-title">{title}</div>
            <div className="product-price">${price}</div>
          </div>
        </div>
        <div className="details">
          <p>{description}</p>
          <div id="ProductAddToCartRoot">
            <ProductAddToCart {...product} />
          </div>
          <div className="detail-section">
            <div className="detail">
              <input
                type="checkbox"
                id="delivery-dropdown"
                className="toggle"
              />
              <label className="title" htmlFor="delivery-dropdown">
                Delivery
              </label>
              <div className="content">
                <p className>
                  The speeds that show are dependent on those made available by
                  the seller. Standard - Should arrive 3 to 10 business days
                  after shipment Expedited - Should arrive 3 to 6 business days
                  after shipment Second Day - Should arrive 2 business days
                  after shipment Next Day - Should arrive by the end of business
                  the day after shipment Pick up - Pick up at our Doral
                  Warehouse facility.
                </p>
              </div>
            </div>
          </div>
          <div className="detail-section">
            <div className="detail">
              <input type="checkbox" id="refund-dropdown" className="toggle" />
              <label className="title" htmlFor="refund-dropdown">
                Refund
              </label>
              <div className="content">
                <p className>
                  NEW! Accepting Returns We accept returns for store credit,
                  within 3 business days of receipt. Items must be tagged and in
                  new/unworn condition. Read more here. 100% Authenticity,
                  Guaranteed We carefully inspect every shoe with a fine toothed
                  comb, twice, to validate its authenticity, and to check for
                  conditional/manufacturing issues to ensure all of our items
                  are pristine . We stand behind every item we sell, so you can
                  feel safe about buying. Learn more about our policies here.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withRouter(Single);
